import React from 'react';
import { useTranslation } from 'react-i18next';
import Button, { ButtonType } from 'legacy/common/components/button/Button';

type DiscountCodesActionsProps = {
  handleAddDiscountCode: () => void;
};

const DiscountCodesActions: React.FC<DiscountCodesActionsProps> = ({
  handleAddDiscountCode
}) => {
  const { t } = useTranslation('events');
  
  return (
    <>
      <div className="w-full bg-white fixed bottom-0 left-0 p-4 z-10 border-t pb-12 md:pb-4">
        <div className="w-full md:w-[343px] mx-auto">
          <div className="flex gap-4">
            <Button type={ButtonType.Primary} onClick={handleAddDiscountCode}>
              <div className="flex items-center justify-center">
                {t('settings.discountCodes.page.addDiscountCode')}
              </div>
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default DiscountCodesActions;
